import * as Sentry from '@sentry/browser';

export interface ErrorResponse {
  response: {
    status: number;
    data: unknown;
  };
}

const sentryError = {
  handleSentryApiError: (error: ErrorResponse, payload: unknown) => {
    if (error.response) {
      const status = error.response.status;
      if (status >= 500) {
        Sentry.configureScope((scope) => {
          scope.setExtra('response_data', JSON.stringify(error.response.data));
          scope.setExtra('response_status', status);
          scope.setExtra('payload', payload);
        });
        Sentry.captureException(error);
      }
    }
  },
  setApplicationId: (applicationId: string) => {
    Sentry.setContext('application', {
      id: applicationId,
    });
  },
};

export default sentryError;
